/**
 * Component: Site search
 */


var ed = ed || {};

ed.siteSearch = new function(){
    /**
     * Init function
     */
    this.init = function() {
        toggleSearchForm();
    };

    /**
     * Toggle search form
     */
    function toggleSearchForm() {
        var siteSearch = $('#site-search'),
            siteSearchButton = $('#site-search-button'),
            siteSearchInput = $('.site-search__input', siteSearch),
            siteSearchClose = $('#site-search-close');

        siteSearch.on('submit', function(e){
            if (!siteSearch.hasClass('expanded')) {
                e.preventDefault();
                siteSearch.addClass('expanded');
                siteSearchInput.focus();
            }
            else {
                return true;
            }
        });

        siteSearchClose.on('click', function(e){
            e.stopPropagation();
            console.log('c');
            siteSearch.removeClass('expanded');
        });
    }
};
